import { Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../FormGroup/FormGroup";
import { Controller } from "react-hook-form";

const isFloatValueAllowed = ({ floatValue }) => {
  const maxAmount = 999_999_999_999.99;
  const minAmount = -999_999_999_999.99;
  return (
    typeof floatValue === "undefined" ||
    (floatValue <= maxAmount && floatValue >= minAmount)
  );
};

function NumericInput({
  name,
  register = (name) => ({}),
  setValue = (name, any) => {},
  error = null,
  label = null,
  addon = null,
  displayAs = Form.Group,
  control = undefined,
  // * "currency" For AmountInput only
  currency = null,
  popoverRef = (el) => ({}),
  popoverHandlers = null,
  md = 6,
  shouldUnregister = true,
  valueIsNumericString = true,
  ...props
}) {
  return (
    <FormGroup
      label={label}
      addon={addon}
      error={error}
      displayAs={displayAs}
      md={md}
    >
      {currency}
      <Controller
        name={name}
        control={control}
        shouldUnregister={shouldUnregister}
        render={({ field: { ref: formRef, onChange, ...rest } }) => (
          <NumericFormat
            customInput={Form.Control}
            allowedDecimalSeparators={[",", "."]}
            decimalSeparator={"."}
            isInvalid={!!error}
            getInputRef={(el) => {
              popoverRef(el);
              formRef(el);
            }}
            isAllowed={valueIsNumericString ? Boolean : isFloatValueAllowed}
            onValueChange={(values) => {
              onChange(
                valueIsNumericString ? values.value : values.floatValue ?? null
              );
            }}
            valueIsNumericString={valueIsNumericString}
            {...popoverHandlers}
            {...rest}
            {...props}
          />
        )}
      />
    </FormGroup>
  );
}

NumericInput.WithPopover = withPopover(NumericInput);
export default NumericInput;
